// Textos chicos de «Inversión sin control» que se arman con `t`.

/** «Gonzalo», «Gonzalo y Macarena», «Ana, Gonzalo y Macarena». */
export function joinNames(names, t) {
    const list = (names || []).filter(Boolean);
    if (list.length <= 1) return list.join('');
    return `${list.slice(0, -1).join(', ')} ${t('alerts_center.uncontrolled.and')} ${list[list.length - 1]}`;
}

/**
 * «8 oct» / «Oct 8» para una fecha `AAAA-MM-DD`, en el idioma de la pantalla: armada a mano como
 * «08/10» se leía al revés en inglés. Una fecha que no se entiende no dice nada.
 */
export function shortDate(isoDate, language) {
    const [year, month, day] = String(isoDate || '').split('-').map(Number);
    if (!year || !month || !day) return '';
    return new Date(Date.UTC(year, month - 1, day))
        .toLocaleDateString(language || 'es', {day: 'numeric', month: 'short', timeZone: 'UTC'});
}

const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/** «hace 5 min», «hace 2 h», «hace 3 días». Una fecha que no se entiende no dice nada. */
export function relativeTime(iso, t, now = Date.now()) {
    const at = Date.parse(iso || '');
    if (!Number.isFinite(at)) return '';
    const elapsed = Math.max(0, now - at);
    if (elapsed < HOUR) return t('alerts_center.uncontrolled.ago_minutes', {count: Math.max(1, Math.round(elapsed / MINUTE))});
    if (elapsed < DAY) return t('alerts_center.uncontrolled.ago_hours', {count: Math.round(elapsed / HOUR)});
    return t('alerts_center.uncontrolled.ago_days', {count: Math.round(elapsed / DAY)});
}
